import request from '@/api/request'

const baseURL = process.env.VUE_APP_END_POINT_FILES
const baseURLKey = process.env.VUE_APP_END_POINT_FILES_KEY
const baseURLAuth = process.env.VUE_APP_END_POINT_FILES_AUTH
const version = 'v1'

let headers1 = {
  'Content-Type': 'application/json',
  'x-api-key': baseURLKey,
  'Authorization': baseURLAuth
}

export default {
  listUpload (payload) {
    const url = `${version}/files/list-upload`
    const path = payload.path
    const data = { path }
    return request({ method: 'POST', headers: headers1, baseURL, url, data })
  },
  requestUpload (payload) {
    const url = `${version}/files/request-upload`
    let data = payload
    return request({ method: 'POST', headers: headers1, baseURL, url, data })
  },
  uploadFile (payload) {
    const url = payload.linkToUpload
    const mimeType = payload.mimeType
    const data = payload.formData
    const headers2 = { 'Content-Type': mimeType }
    const config = {
      method: 'PUT',
      headers: headers2,
      baseURL: url,
      data,
      onUploadProgress: function (progressEvent) {
        payload.progress(progressEvent.lengthComputable, progressEvent.loaded, progressEvent.total)
      }
    }
    return request(config)
  },
  confirmUpload (payload) {
    const url = `${version}/files/confirm-upload`
    const pathfile = payload.pathfile
    const data = { pathfile }
    return request({ method: 'POST', headers: headers1, baseURL, url, data })
  },
  deleteUpload (payload) {
    const url = `${version}/files/delete-upload`
    const pathfile = payload.pathfile
    const data = { pathfile }
    return request({ method: 'POST', headers: headers1, baseURL, url, data })
  }
}
